"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateBattery = exports.CalculateVoltageFromBattery = exports.CalculateBatteryFromVoltages = exports.lipoVoltageArray = void 0;
const util_1 = require("../../util");
/**
 * @exports https://blog.ampow.com/lipo-voltage-chart/
 *
 * https://docs.google.com/spreadsheets/d/1d4nQKwsdbR-UDWHC8PouWinJUh7O0zSDvPPbT041Ns0/edit?gid=0#gid=0
 */
exports.lipoVoltageArray = [
    2.96, 3.24, 3.41, 3.51, 3.58, 3.63, 3.665, 3.695, 3.72, 3.74, 3.76, 3.78, 3.802, 3.826, 3.852, 3.876, 3.904, 3.934, 3.966, 4.011, 4.111,
];
const modifiedVoltageArray = (minVoltage, maxVoltage) => {
    let base = exports.lipoVoltageArray[0];
    let diff = exports.lipoVoltageArray[exports.lipoVoltageArray.length - 1] - exports.lipoVoltageArray[0];
    let cummulative = exports.lipoVoltageArray.map((val) => {
        let calc = (val - base) / diff;
        return calc;
    });
    let converted = cummulative.map((val) => {
        let conv = minVoltage;
        let diff = (maxVoltage - minVoltage) * val;
        return conv + diff;
    });
    return converted;
};
const calculateSpecificPercentage = (voltage, voltageArray) => {
    let length = voltageArray.length;
    if (length < 1)
        throw new Error('FFS, calculateSpecificPercentage');
    let percentageIncrement = 100 / (length - 1);
    let exact = voltageArray.findIndex((val) => val === voltage);
    let upper = voltageArray.findIndex((val) => val >= voltage);
    let index = exact !== -1 ? exact : upper - 1;
    let fromIndex = percentageIncrement * index;
    let granular = 0;
    if (exact !== upper) {
        granular = ((voltage - voltageArray[index]) / (voltageArray[upper] - voltageArray[index])) * percentageIncrement;
    }
    return fromIndex + granular;
};
const calculateVoltage = (percentage, voltageArray) => {
    let length = voltageArray.length;
    let percentageIncrement = 100 / (length - 1);
    if (length < 2)
        throw new Error('FFS, calculateVoltage');
    let index = Math.floor(percentage / percentageIncrement);
    let remainder = percentage - index * percentageIncrement;
    let remainderPercentage = remainder / percentageIncrement;
    let voltDiff = voltageArray[index + 1] - voltageArray[index];
    let voltBetween = voltDiff * remainderPercentage;
    return voltageArray[index] + voltBetween;
};
/**
 * @exports https://docs.google.com/spreadsheets/d/1d4nQKwsdbR-UDWHC8PouWinJUh7O0zSDvPPbT041Ns0/edit#gid=0
 */
const CalculateBatteryFromVoltages = (voltage, minVoltage = 2.96, maxVoltage = 4.2) => {
    if (voltage >= maxVoltage) {
        return 100;
    }
    else if (voltage <= minVoltage) {
        return 0;
    }
    let calcVoltageArray = modifiedVoltageArray(minVoltage, maxVoltage);
    let res = calculateSpecificPercentage(voltage, calcVoltageArray);
    return (0, util_1.roundDecimals)(res, 0);
};
exports.CalculateBatteryFromVoltages = CalculateBatteryFromVoltages;
const CalculateVoltageFromBattery = (percentage, minVoltage = 2.96, maxVoltage = 4.2) => {
    if (percentage >= 100) {
        return maxVoltage;
    }
    else if (percentage <= 0) {
        return minVoltage;
    }
    let calcVoltageArray = modifiedVoltageArray(minVoltage, maxVoltage);
    let res = calculateVoltage(percentage, calcVoltageArray);
    return res;
};
exports.CalculateVoltageFromBattery = CalculateVoltageFromBattery;
const CalculateBattery = (device) => {
    if (device.batteryCapacity) {
        return (0, exports.CalculateBatteryFromVoltages)(device.batteryCapacity, device.minVoltage, device.maxVoltage);
    }
    return undefined;
};
exports.CalculateBattery = CalculateBattery;
